var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5137 12.479C25.3716 12.4976 26.2344 12.4412 27.0889 12.5083C27.9543 12.6694 28.1628 13.9768 27.394 14.4049C26.8695 14.687 26.2463 14.51 25.6776 14.5597H24.5137V12.479V12.479ZM27.585 10.124C27.7756 10.7954 27.127 11.3982 26.479 11.3057H24.5137C24.5275 10.6726 24.4867 9.98535 24.5337 9.38554C25.321 9.40767 26.1156 9.34041 26.8983 9.42071C27.2346 9.50504 27.5161 9.78095 27.585 10.124V10.124ZM32.3148 0.167413C32.3514 1.4496 32.3201 2.79956 32.3306 4.10776C32.3282 9.42642 32.3357 14.7449 32.3264 20.0639C32.2919 22.0572 30.5217 23.7892 28.5381 23.829C26.5525 23.8371 24.5667 23.8302 22.5809 23.8324V15.7917C24.7445 15.7806 26.9093 15.8144 29.072 15.7749C30.0753 15.712 31.1743 15.0514 31.221 13.9496C31.3391 12.843 30.2937 12.0776 29.3011 11.9567C28.9195 11.9468 28.9307 11.8457 29.3011 11.8016C30.2478 11.5974 30.9912 10.6197 30.7126 9.64043C30.4753 8.61048 29.3346 8.21185 28.3857 8.21383C26.4511 8.20072 24.516 8.212 22.5813 8.20819C22.5938 6.70709 22.5552 5.20437 22.6021 3.70437C22.7554 1.74705 24.5701 0.132905 26.5259 0.167925C28.4558 0.167632 30.3854 0.167632 32.3148 0.167559V0.167413Z",
    fill: "url(#paint0_linear_5120_10682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.717476 3.90708C0.766885 1.91694 2.54466 0.199127 4.52573 0.170041C6.50393 0.16396 8.48243 0.169162 10.4606 0.167404C10.4552 6.82599 10.4713 13.4853 10.4525 20.1435C10.3763 22.1095 8.61788 23.7945 6.6584 23.8293C4.67645 23.8365 2.69428 23.8304 0.712264 23.8324V15.5206C2.63746 15.9744 4.65633 16.1676 6.62037 15.8666C7.79437 15.6781 9.07886 15.1027 9.47634 13.8873C9.76883 12.8476 9.60415 11.7534 9.64769 10.6863V8.20818H6.24873C6.23346 9.84717 6.28001 11.489 6.22414 13.126C6.13252 14.1322 5.13398 14.7715 4.18302 14.7374C3.00366 14.7498 0.666598 13.8844 0.666598 13.8844C0.660725 10.8137 0.700811 6.96797 0.717476 3.90738V3.90708Z",
    fill: "url(#paint1_linear_5120_10682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7277 9.20778C11.5488 9.24566 11.6917 8.59962 11.646 8.35455C11.6582 6.80502 11.6205 5.25381 11.6668 3.70538C11.8196 1.73978 13.6483 0.121604 15.612 0.167614H21.3948C21.3894 6.8262 21.4055 13.4855 21.3867 20.1437C21.3104 22.1097 19.5519 23.7947 17.5923 23.8296C15.6103 23.837 13.6281 23.8307 11.6459 23.8326V14.7259C12.9996 15.8344 14.8395 16.0069 16.526 16.0099C17.7974 16.0095 19.0614 15.8138 20.2961 15.5212V13.8529C18.9047 14.5449 17.269 14.9845 15.7265 14.5869C14.6505 14.3196 13.8695 13.2819 13.8869 12.1738C13.7622 11.0214 14.4391 9.80481 15.5739 9.46223C16.9828 9.02206 18.5184 9.35871 19.8391 9.93097C20.122 10.0788 20.4092 10.2622 20.2961 9.79023V8.47888C18.0873 7.95446 15.7367 7.76148 13.5176 8.33199C12.8753 8.5128 12.2495 8.78703 11.7277 9.20793V9.20778Z",
    fill: "url(#paint2_linear_5120_10682)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5120_10682",
    x1: 22.5143,
    y1: 11.4939,
    x2: 32.2691,
    y2: 11.4939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5120_10682",
    x1: 0.504855,
    y1: 12.2265,
    x2: 10.3008,
    y2: 12.2265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5120_10682",
    x1: 11.6316,
    y1: 11.7234,
    x2: 21.393,
    y2: 11.7234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.8a87356ce59208b0ecd9535b276f3289.svg";
export { ForwardRef as ReactComponent };